module.exports = __webpack_public_path__ + "img/face-no2.e9d80586.png";